import { withInstall } from '../../utils';
import Form from './src/form.vue';

export * from './src/form';

export const IForm = withInstall(Form); // 增加类型

export default IForm;
